// Lightweight, anonymous funnel event tracking (fire-and-forget).
export function trackEvent(event, extra = {}) {
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/track/event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ event, path: window.location.pathname, ...extra }),
    }).catch(() => {});
  } catch (e) {
    /* no-op */
  }
}
